import React, { Component } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  TextField,
  Snackbar,
  Slide,
} from "@material-ui/core";
import Http from "../../../Http";

export default class GuiaComment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingSave: false,
      openForm: false,
      comentario: "",
      id_guia: false,
      comentarios: [],
      sbOpen: false,
      sbMsg: '',
    };
  }

  componentDidMount() {
    this.getInfo(this.props.id);
    this.setState({ id_guia: this.props.id });
  }

  getInfo = async (id_guia) => {
    const Res = await Http.get(`comentarios/${id_guia}/filter`);
    if (Res && Res.data) {
      this.setState({ comentarios: Res.data.reverse() });
    }
  };

  openForm = () => {
    this.setState({ openForm: true });
  };

  onSubmit = async () => {
    const { comentario, id_guia } = this.state;
    this.setState({ loadingSave: true });

    if (comentario.length > 5 && comentario.length < 255) {
      const Res = await Http.post("comentario/save", { comentario, id_guia });
      if (!Res.error) {
        this.setState({ loadingSave: false, openForm: false });
        this.getInfo(id_guia);
      }
    } else if (comentario.length > 255) {
      // validacion de longitud
      this.setState({ sbMsg: 'Mensaje muy largo, maximo 255 caracteres', sbOpen: true });
    }
  };

  render() {
    const { comentarios, openForm, loadingSave, comentario, sbMsg, sbOpen } = this.state;
    return (
      <div style={{ width: "700px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            margin: "15px 0px",
          }}
        >
          {!openForm ? (
            <Button
              variant="contained"
              color={"primary"}
              onClick={this.openForm}
            >
              Nuevo
            </Button>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                width: "100%",
                alignItems: "flex-end",
              }}
            >
              <TextField
                minRows={4}
                autoFocus
                multiline
                fullWidth
                variant="outlined"
                className="form-field"
                type="textarea"
                label={`Información`}
                value={comentario}
                onChange={(e) => {
                  this.setState({ comentario: e.target.value });
                }}
              />
              <Button
                style={{ maxWidth: 100 }}
                variant="contained"
                color={"primary"}
                onClick={this.onSubmit}
                disabled={loadingSave}
              >
                Guardar
              </Button>
            </div>
          )}
        </div>
        {comentarios.length > 0 ? (
          comentarios.map((comment) => (
            <Accordion key={comment.id}>
              <AccordionSummary
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>
                  <strong>{comment.titulo}</strong>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{comment.comentario}</Typography>
              </AccordionDetails>
            </Accordion>
          ))
        ) : (
          <span>Sin Comentarios</span>
        )}

        <Snackbar
          resumeHideDuration={2000}
          autoHideDuration={2000}
          open={sbOpen === undefined ? false : sbOpen}
          onClose={() => {
            this.setState({ sbOpen: false });
          }}
          TransitionComponent={Slide}
          message={<span>{sbMsg}</span>}
        />
      </div>
    );
  }
}
